export abstract class AbstractStorage {
    abstract initialize(): void;
    abstract set(name: string, value: any): void;
    abstract get(name: string, defaultValue?: any): any;
}
